import { FunctionComponent, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useGenericListSettings, IFilter, FilterValueType } from '@knowmax/genericlist-core'
import { FilterCustom, FilterText, FilterOptions, FilterBoolean } from '.'

/** Renders a single filter. Serializes and deserializes in query params of url. */
export const Filter: FunctionComponent<{ filter: IFilter, listId?: string }> = observer(({ filter, listId }) => {
  const settings = useGenericListSettings()

  const visible = useMemo(() => {
    return !filter.isAvailable || filter.isAvailable(filter, settings.params)
  }, [filter, settings.params])

  return (
    <>
      {visible &&
        <>
          {filter.renderCustom ?
            <FilterCustom filter={filter} listId={listId} /> :
            filter.valueType === FilterValueType.boolean ?
              <FilterBoolean filter={filter} listId={listId} /> :
              filter.options ?
                <FilterOptions filter={filter} listId={listId} /> :
                <FilterText filter={filter} listId={listId} />
          }
        </>
      }
    </>
  )
})